
<app-error-page [errorMsg]="errorMsg" *ngIf="containsError"></app-error-page>

<div *ngIf="!containsError">
  <div class="pageHeader" id="serviceTransfersListHeader">List of Servicer Transfers</div>

  <div *ngIf="noTranSel != null && noTranSel.length >0" class="no-trans-selected">
    <li class="error-list-msg">{{noTranSel}}</li>

  </div>

  <div *ngIf="deleteFlag && !deleteConfirmFlag">
  <p> Do you really want to delete the following loans from the servicing transfer? </p>

</div>

  <div *ngIf="deleteConfirmFlag">
    <p> The following loans have been deleted successfully from the servicing transfer.</p>

  </div>



  <div *ngIf="partialLoanDisplayList" class="u-scroll-x">
    <fm-table [columns]="displayCols" [value]="partialLoanDisplayList"
              [paginator]="true" [rows]="10"
              [compressed]="true" [autoLayout]="true"
              [rowsPerPageOptions]="[10,25,50]" [enableTableEntryTotal]="true">
      <ng-template fmTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" class="row-selection">
            {{col.header}}
          </th>
        </tr>
      </ng-template>
      <ng-template fmTemplate="body" let-rowData let-columns="columns">
        <tr>
          <td class="td-content" *ngFor="let col of columns">
            <span *ngIf="col.header==='Delete ?' && !deleteFlag && ((this.isAdminrole === 'true') || (this.internalUpdateRoleFlag === 'true') || (this.externalUpdateRoleFlag === 'true'))">
              <fm-checkbox #deleteCheckbox [value]="rowData"  [disabled]="! ((rowData['TRAN_STAT_DESC']) === 'Pending' || (rowData['TRAN_STAT_DESC']) ==='Pending For Approval')"></fm-checkbox>
            </span>
            <span *ngIf="col.header==='Loan Number' "> {{(rowData[col.field])}}</span>
            <span *ngIf="col.header==='Transaction Status' "> {{(rowData[col.field])}}</span>

          </td>
        </tr>
      </ng-template>
    </fm-table>
  </div>
  <span></span>

  <!--<div style="margin-bottom: 150px;" *ngIf="!approveTransferFlag">
    <button fmButton type="submit" [primary]="true" [small]="true" label="Yes"
            (click)="confimrmApproveOrDelete()" class="buttonmargin"></button>

    <button fmButton type="button" (click)="cancelButton()" [primary]="true" label="No" [small]="true" class="buttonmargin"></button>
  </div>-->
  <div class="u-mb-150" *ngIf="!deleteFlag">
    <div *ngIf="(this.isAdminrole === 'true') || (this.internalUpdateRoleFlag === 'true')
      || (this.externalUpdateRoleFlag === 'true')">
    <button  fmButton type="submit" [primary]="true" [small]="true" label="Select All"
            (click)="selectAll()" class="buttonmargin"></button>

    <button  fmButton type="button" (click)="unSelectAll()" [primary]="true" label="Unselect All" [small]="true" class="buttonmargin"></button>

    <button fmButton type="button"  [primary]="true" (click)="deleteLoanTrans()" label="Delete" [small]="true" class="buttonmargin"></button>

    </div>
    <button fmButton type="button" (click)="cancelButton()" [primary]="true" label="Cancel" [small]="true" class="buttonmargin"></button>
  </div>

  <div class="u-mb-150" *ngIf="deleteFlag && !deleteConfirmFlag">
    <button  fmButton type="submit" [primary]="true" [small]="true" label="Yes"
             (click)="confirmDelete()" class="buttonmargin"></button>

    <button  fmButton type="button" (click)="cancelDelete()" [primary]="true" label="No" [small]="true" class="buttonmargin"></button>
  </div>
</div>
